import axios from 'axios'
import CStorage from "./CStorage";
import Vue from "vue";

export default {
    login(email, password) {
        return axios.post('user/login', {user: {email, password}}).then(response => {
            return response.data
        })
    },

    oneTimeLogin(onetimelogin) {
        return axios.post('user/onetimelogin', {user: {onetimelogin}}).then(response => {
            return response.data
        })
    },

    check() {
        return axios.post('user/check').then(response => {
            return response.data
        })
    },

    registration(username, email, password) {
        return axios.post('user/registration', {user: {username, email, password}}).then(response => {
            return response.data
        })
    },

    shortRegistration(username, email, returnUrl) {
        return axios.post('user/shortreg', {user: {username, email, returnUrl}}).then(response => {
            return response.data
        })
    },

    async orderRegistration(username, email, phone) {
        const response = await axios.post('user/orderreg', {user: {username, email, phone}})
        return response.data.user
    },

    recovery(login) {
        return axios.post('user/recovery', {user: {login}}).then(response => {
            return response.data
        })
    },

    simpleRecovery(login, returnUrl) {
        return axios.post('user/simple-recovery', {login: login, returnUrl: returnUrl}).then(response => {
            return response.data
        })
    },

    password(oldPassword, password) {
        return axios.post('user/password', {user: {oldPassword, password}}).then(response => {
            return response.data
        })
    },

    phone(phone) {
        return axios.post('user/phone', {user: {phone}}).then(response => {
            return response.data
        })
    },

    utm() {
        const utm_source = CStorage.getItem("utm_source", "")
        const utm_campaign = CStorage.getItem("utm_campaign", "")
        if (utm_source || utm_campaign)
            axios.post('user/utm', {utm_source: utm_source, utm_campaign: utm_campaign})
    },

    pushFromRefId() {
        const from_ref_id = CStorage.getItem("from_ref_id", null)
        const from_ref_id_created = CStorage.getItem("from_ref_id_created", null)
        if (from_ref_id && from_ref_id_created)
            axios.post('user/ref', {from_ref_id: from_ref_id, from_ref_id_created: from_ref_id_created})
    },

    pushTimezone() {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        const offset = new Date().getTimezoneOffset()
        if (timezone || offset)
            axios.post('user/timezone', {timezone: timezone, timezone_offset: offset})
    },

    pushCid() {
        setTimeout(() => {
            let client_id = null
            console.log("metrika", Vue.prototype.$metrika)
            if (Vue.prototype.$metrika && Vue.prototype.$metrika.getClientID()) client_id = Vue.prototype.$metrika.getClientID()
            if (client_id)
                axios.post('user/cid', {cid: client_id})
        }, 2000)
    },

    pushUserContext() {
        this.utm()
        this.pushTimezone()
        this.pushFromRefId()
        this.pushCid()
    },

    getTimezoneOffset() {
        return new Date().getTimezoneOffset()
    },

    isMskTimezone() {
        return new Date().getTimezoneOffset() === -180
    },

    remove(email, password) {
        return axios.post('user/remove', {user: {email, password}}).then(response => {
            return response.data
        })
    },

    logout() {
        return axios.post('user/logout').then(response => {
            return response.data
        })
    },

    updateProfile(profile) {
        return axios.put('profiles/' + profile.user_id, profile).then(response => {
            return response.data
        })
    },

    async updateProfileAsync(profile) {
        const response = await axios.put('profiles/' + profile.user_id, profile)
        return response.data
    },

    fetchProfile() {
        return axios.get('user/profile?expand=userCourses,userCourses.course,userCourses.course.isAdditionalPackage,userCourses.payments,userCourses.course.flRecurrent,oneOffSubscriptionIds,oneOffSubscriptionTimetablesIds').then(response => {
            return response.data
        })
    },


    fetchCRMProfile() {
        return axios.get('user/profile?expand=timetablesIdsWithActiveSubscriptions,activeCRMIndividualSubscriptionId,individualTimetableId').then(response => {
            return response.data
        })
    },

    fetchCRMSubscriptionsIds(timetableId, subscriptionId) {
        return axios.post('user/crm-subscriptions-ids', {
            timetableId: timetableId,
            subscriptionId: subscriptionId
        }).then(response => {
            return response.data
        })
    },

    fetchCRMIndSubscriptionsIds(timetableId, subscriptionId) {
        return axios.post('user/crm-ind-subscriptions-ids', {
            subscriptionId: subscriptionId
        }).then(response => {
            return response.data
        })
    },

    fetchLastActiveCRMSubscription(timetableId) {
        return axios.get('user/last-active-crm-subscription/' + timetableId)
            .then(response => {
                return response.data
            })
    },

    fetchCRMSubscriptions() {
        return axios.get('user/crm-subscriptions')
            .then(response => {
                return response.data
            })
    },

    fetchTimetables() {
        return axios.get('user/crm-timetables-subscriptions')
            .then(response => {
                return response.data
            })
    },

    trackEvent(event, params) {
        return axios.post('events', {event: event, params: params})
            .then(response => {
                return response.data
            })
    },

    trackNonUniqEvent(event, params) {
        return axios.post('events', {event: event, params: params, nonuniq: 1})
            .then(response => {
                return response.data
            })
    },

    fetchExams() {
        return axios.get('usersexams/my?expand=exam,examResult,exam.maxPoints').then(response => {
            return response.data
        })
    },

    fetchStudyProducts() {
        return axios.get('user-study-products/my?expand=studyProduct,studyProduct.subscriptions,studyProduct.courses,crmSubscriptions').then(response => {
            return response.data
        })
    },

    fetchRefOrders() {
        return axios.get('user/ref-orders')
            .then(response => {
                return response.data
            })
    },

    fetchRefPayed() {
        return axios.get('user/ref-payed')
            .then(response => {
                return response.data
            })
    },


    fetchRefFailed() {
        return axios.get('user/ref-failed')
            .then(response => {
                return response.data
            })
    },

    checkLogin(login) {
        return axios.post('phones/check-login', {login: login}).then(response => {
            return response.data
        })
    },

    requestRegisterCode(login) {
        return axios.post('phones/request-register-code', {login: login}).then(response => {
            return response.data
        })
    },

    confirmRegisterCode(code, login, username) {
        return axios.post('phones/confirm-register-code', {
            code: code,
            login: login,
            username: username
        }).then(response => {
            return response.data
        })
    },

    requestLoginCode(login) {
        return axios.post('phones/request-login-code', {login: login}).then(response => {
            return response.data
        })
    },

    confirmLoginCode(code, login) {
        return axios.post('phones/confirm-login-code', {code: code, login: login}).then(response => {
            return response.data
        })
    },

    requestCode(phone) {
        return axios.post('phones/request-code', {phone: phone}).then(response => {
            return response.data
        })
    },

    confirmCode(code) {
        return axios.post('phones/confirm-code', {code: code}).then(response => {
            return response.data
        })
    },

    requestEmailCode(email) {
        return axios.post('emails/request-code', {email: email}).then(response => {
            return response.data
        })
    },

    confirmEmailCode(code, email) {
        return axios.post('emails/confirm-code', {code: code, email: email}).then(response => {
            return response.data
        })
    },
}
